export default "__VITE_ASSET__11b47926__"